/**
 * 通知公告类型配置 -- 系统管理员
 * Bai.Zhiming 
 * 2019-6-25
 */
angular.module("typeConfigAdminModule", []).
controller("typeConfigAdminCtrl", ["$scope", "trsHttpService", "$q", "modalDialog", "noticeService", function($scope, trsHttpService, $q, modalDialog, noticeService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 状态初始化
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            statusList: [{ name: '全部', value: -1 }, { name: '启用', value: 0 }, { name: '禁用', value: 1 }],
            keywords: '',
            hotLists: {
                page: {
                    'pn': 0,
                    'PAGESIZE': 20,
                    'PAGECOUNT': 0,
                    'ITEMCOUNT': 0
                },
                status: {
                    'jumpToPageNum': 1,
                    'startpage': 0
                }
            },
        }
        $scope.data = {
            selectedArray: [],
            tableData: [],
        }
    }
    /**
     * [initData description] 数据初始化
     * @return {[type]} [description]
     */
    function initData() {
        $scope.status.selectedStatus = $scope.status.statusList[0];
        getNoticeTypeList();
    }
    /**
     * [getNoticeTypeList description] 获取公告类型列表
     * @return {[type]} [description]
     */
    function getNoticeTypeList() {
        let defer = $q.defer();
        let params = {
            serviceid: 'noticetype',
            method: 'noticetypeList',
            pageNumber: $scope.status.hotLists.page.startpage,
            pageSize: $scope.status.hotLists.page.PAGESIZE,
            keyWords: $scope.status.keywords
        };
        if ($scope.status.selectedStatus.value > -1) {
            params.status = $scope.status.selectedStatus.value;
        }
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(result) {
            $scope.data.tableData = result == '' ? [] : result.data.content;
            $scope.status.hotLists.page.pn = result.data.number + 1;
            $scope.status.hotLists.page.PAGESIZE = result.data.size;
            $scope.status.hotLists.page.PAGECOUNT = result.data.totalPages;
            $scope.status.hotLists.page.ITEMCOUNT = result.data.totalElements;
        });
    }
    /**
     * [editNotice description] 公告类型编辑
     * @param  {[type]} notice [description] 公告
     * @return {[type]}        [description]
     */
    function editNoticeType(notice) {
        let defer = $q.defer();
        let params = {
            serviceid: 'noticetype',
            method: 'updateNoticetype',
            typeid: notice.typeid,
            status: notice.status,
            typename: notice.typename
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "POST").then(function(data) {
            defer.resolve();
        });
        return defer.promise;
    }
    /**
     * [stopOrStart description] 公告类型启用/停用
     * @param  {[type]} item [description] 公告类型
     * @return {[type]}      [description]
     */
    $scope.stopOrStart = function(item) {
            modalDialog.confirmModal('提示信息', item.status == 0 ? "确定停用？" : "确认启用？", function() {
                item.status = item.status == 0 ? 1 : 0;
                editNoticeType(item).then(() => {
                    modalDialog.alertType('', '状态修改成功', 'success', false);
                    getNoticeTypeList();
                });
            });
        }
        /**
         * [edit description] 编辑/新建公告类型
         * @param  {[type]} item [description] 公告类型
         * @return {[type]}      [description]
         */
    $scope.edit = function(item) {
            noticeService.editNoticeType(item).then(() => {
                let tips = '新建公告类型成功';
                if (angular.isDefined(item)) {
                    tips = '编辑公告类型成功';
                }
                modalDialog.alertType('', tips, 'success', false);
                getNoticeTypeList();
            });
        }
        /**
         * [requestData description] 数据请求
         * @param  {[type]} ev [description]
         * @return {[type]}    [description]
         */
    $scope.requestData = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                getNoticeTypeList();
            }
        }
        /**
         * [isChecked description] 判断数据是否选中
         * @param  {[type]}  item [description] 数据
         * @return {Boolean}      [description]
         */
    $scope.isChecked = function(item) {
            return $scope.data.selectedArray.some((_item) => {
                return _item.typeid == item.typeid;
            });
        }
        /**
         * [selectItem description] 选中/取消选中数据
         * @param  {[type]} item [description] 数据
         * @return {[type]}      [description]
         */
    $scope.selectItem = function(item) {
            if ($scope.isChecked(item)) {
                var index = $scope.data.selectedArray.indexOf(item);
                $scope.data.selectedArray.splice(index, 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
        }
        /**
         * [selectAll description] 全选/取消全选
         * @return {[type]} [description]
         */
    $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.tableData.length > 0 && $scope.data.tableData.length == $scope.data.selectedArray.length ? [] : [].concat($scope.data.tableData);
        }
        /**
         * [pageChanged description]分页请求
         * @return {[type]} [description]
         */
    $scope.pageChanged = function() {
        $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.pn;
        $scope.status.hotLists.page.startpage = $scope.status.hotLists.page.pn - 1;
        getNoticeTypeList();
    };
    $scope.jumpToPage = function() {
        if ($scope.status.hotLists.status.jumpToPageNum > $scope.status.hotLists.page.PAGECOUNT) {
            $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.PAGECOUNT;
        }
        if ($scope.status.hotLists.status.jumpToPageNum === "0" || isNaN(Number($scope.status.hotLists.status.jumpToPageNum))) {
            modalDialog.alertType("请输入合法的页码", "", "warning", false);
            return;
        }
        $scope.status.hotLists.page.startpage = $scope.status.hotLists.status.jumpToPageNum - 1;
        getNoticeTypeList();
    };
    /**
     * [searchFn description] 搜索函数
     */
    $scope.searchFn = function() {
            clearPage()
            getNoticeTypeList()
        }
        /**
         * [clearPage  description] 清除page信息
         */
    function clearPage() {
        $scope.status.hotLists = {
            page: {
                'pn': 0,
                'PAGESIZE': 20,
                'PAGECOUNT': 0,
                'ITEMCOUNT': 0
            },
            status: {
                'jumpToPageNum': 1,
                'startpage': 0
            }
        }
    }
}]);